import { constants } from '@wix/motion-edm-autogen-common';
import { transformations } from '../common';
const { ARRAY_ITEMS_PATH_PROPERTY_NAME, ARRAY_ITEM_TRANSFORMATION_PROPERTY_NAME, } = transformations;
const { DEFAULT_REQUEST_QUERY_OBJECT_PROPERTY_NAME } = constants;
const ITEMS_RESULT_PROPERTY_NAME = 'items';
const PAGING_METADATA_RESULT_PROPERTY_NAME = 'pagingMetadata';
const buildRequestTransformation = ({ requestQueryObjectPropertyName = DEFAULT_REQUEST_QUERY_OBJECT_PROPERTY_NAME, } = {}) => ({
    [requestQueryObjectPropertyName]: '$[0]',
    '*': '$[1]',
});
const buildResponseTransformation = ({ responseMessageResultPath, responseMessagePagingMetadataPath, itemTransformation, }) => ({
    [ITEMS_RESULT_PROPERTY_NAME]: itemTransformation
        ? {
            [ARRAY_ITEMS_PATH_PROPERTY_NAME]: `$.${responseMessageResultPath}`,
            [ARRAY_ITEM_TRANSFORMATION_PROPERTY_NAME]: itemTransformation,
        }
        : `$.${responseMessageResultPath}`,
    [PAGING_METADATA_RESULT_PROPERTY_NAME]: `$.${responseMessagePagingMetadataPath}`,
});
export { buildRequestTransformation, buildResponseTransformation, ITEMS_RESULT_PROPERTY_NAME, PAGING_METADATA_RESULT_PROPERTY_NAME, };
//# sourceMappingURL=query.js.map